import { AttributeDataType, IAttribute, IAttributeTemplate } from '@alberta/konexi-shared';
import { AttributeTemplateDB } from '@common/repository/databases';
import { QueryService } from '@services/query/query.service';
import { ignore } from 'src/app/common/tracking/tracker';

export class AttributeViewModel implements IAttribute {
  attributeTemplateId?: string;
  public name: string;
  public dataType: AttributeDataType;
  public value?: boolean | string | number | Date;
  @ignore() public new: boolean;
  @ignore() public notFoundInProductGroup: boolean;

  public static async fromTemplate(templateId: string, queryService: QueryService): Promise<AttributeViewModel> {
    const template = await queryService.get<IAttributeTemplate>(templateId, AttributeTemplateDB);
    const attribute = new AttributeViewModel();
    attribute.attributeTemplateId = template._id;
    attribute.name = template.name;
    attribute.dataType = template.dataType;
    attribute.value = null;
    attribute.new = true;
    return attribute;
  }
}
